export class GetShowRequest {
    ChannelNumbers: number[];
    DateStart?: string;
    DateEnd?: string;
}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/FMAPI/get-show-request.ts